export default __webpack_public_path__ + "static/brown-af31244dd99bda95648bf47be159cbef.jpg";